// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { CommandTarget, CommandTargetT, verifyCommandTarget } from "./command-target";

/**
 * Send `commands` in order. A one-shot rule refuses an inactive control.
 */
export class CommandRule implements flatbuffers.IUnpackableObject<CommandRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CommandRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCommandRule(bb: flatbuffers.ByteBuffer, obj?: CommandRule): CommandRule {
    return (obj || new CommandRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCommandRule(
    bb: flatbuffers.ByteBuffer,
    obj?: CommandRule,
  ): CommandRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CommandRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  commands(index: number, obj?: CommandTarget): CommandTarget | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new CommandTarget()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  commandsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  oneShot(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startCommandRule(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addCommands(builder: flatbuffers.Builder, commandsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, commandsOffset, 0);
  }

  static createCommandsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startCommandsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOneShot(builder: flatbuffers.Builder, oneShot: boolean) {
    builder.addFieldInt8(1, +oneShot, +false);
  }

  static endCommandRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // commands
    return offset;
  }

  static createCommandRule(
    builder: flatbuffers.Builder,
    commandsOffset: flatbuffers.Offset,
    oneShot: boolean,
  ): flatbuffers.Offset {
    CommandRule.startCommandRule(builder);
    CommandRule.addCommands(builder, commandsOffset);
    CommandRule.addOneShot(builder, oneShot);
    return CommandRule.endCommandRule(builder);
  }

  unpack(): CommandRuleT {
    return new CommandRuleT(
      this.bb!.createObjList<CommandTarget, CommandTargetT>(
        this.commands.bind(this),
        this.commandsLength(),
      ),
      this.oneShot(),
    );
  }

  unpackTo(_o: CommandRuleT): void {
    _o.commands = this.bb!.createObjList<CommandTarget, CommandTargetT>(
      this.commands.bind(this),
      this.commandsLength(),
    );
    _o.oneShot = this.oneShot();
  }

  unpackFields(...fields: string[]): CommandRuleT {
    const t = new CommandRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("commands")) {
      t.commands = this.bb!.createObjList<CommandTarget, CommandTargetT>(
        this.commands.bind(this),
        this.commandsLength(),
      );
    }
    if (fieldSet.has("one_shot")) {
      t.oneShot = this.oneShot();
    }
    return t;
  }
}

export class CommandRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public commands: CommandTargetT[] = [],
    public oneShot: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.commands === null || this.commands === undefined) {
      throw new Error('Required field "commands" is not set');
    }
    const commands = CommandRule.createCommandsVector(
      builder,
      builder.createObjectOffsetList(this.commands),
    );

    return CommandRule.createCommandRule(builder, commands, this.oneShot);
  }

  clone(): CommandRuleT {
    const obj = new CommandRuleT();
    obj.commands = this.commands.map((e) => e.clone());
    obj.oneShot = this.oneShot;
    return obj;
  }

  equals(other: CommandRuleT): boolean {
    if (this.commands.length !== other.commands.length) return false;
    for (let i = 0; i < this.commands.length; i++) {
      const a = this.commands[i];
      const b = other.commands[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.oneShot !== other.oneShot) return false;
    return true;
  }
}

export function verifyCommandRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyCommandTarget);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "commands");
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}
